// @/firebase.js
import { initializeApp } from "firebase/app";
import {
  updateProfile,
  getAuth,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  createUserWithEmailAndPassword
} from "firebase/auth";

// 👇 Exporta la config para usarla en la app secundaria
export const firebaseConfig = {
  apiKey: "AIzaSyCOT2uiO7ikOvwvoWrAMhH90MiP0y_JXdc",
  authDomain: "appserviceficenca.firebaseapp.com",
  projectId: "appserviceficenca",
  storageBucket: "appserviceficenca.firebasestorage.app",
  messagingSenderId: "1033977014236",
  appId: "1:1033977014236:web:49d04f49294c18a8af1119",
  measurementId: "G-GPJF6KLS67"
};

const app = initializeApp(firebaseConfig);

export {
  app,
  updateProfile,
  getAuth,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  createUserWithEmailAndPassword
};
